import {Component, HostListener, OnInit} from '@angular/core';
import {IconComponent} from '../elements/icon/icon.component';
import {Icon, Icons,} from '../../model/icon';
import {NgIf, Location} from "@angular/common";
import {MenuComponent} from "../elements/menu/menu.component";
import {ScrollService} from "../../services/scroll-service";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {NavigationService} from "../../services/navigation-service";
import {HeightService} from "../../services/height-service";

@Component({
  selector: 'app-header',
    imports: [
        IconComponent,
        NgIf,
        MenuComponent,
        RouterLink
    ],
  templateUrl: './header.component.html',
  standalone: true,
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
    constructor(private scroll: ScrollService,
                private router: Router,
                private route: ActivatedRoute,
                private navigation: NavigationService,
                public location: Location,
                private heightService: HeightService,) {}

    openMenu: boolean = false;
    lastScrollTop = 0;
    limit = 0;
    headerTransparent: boolean = false;
    icon: Icon = Icons.win;
    class: string = '';
    isTop: boolean = true;
    background: string = '';


    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (this.location.path() == '') {
            this.headerTransparent = (document.body.scrollHeight || document.documentElement.scrollHeight) -
                this.heightService.getActiveHeight()  <
                (window.scrollY || window.pageYOffset) + 75;
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            this.limit = window.innerHeight;
            const isTop = currentScrollTop > this.limit - 75;
            this.lastScrollTop = currentScrollTop;
            this.isTop = isTop;
            if (isTop) {
                this.class = 'header-el-title-visible';
            } else {
                this.class = 'header-el-title';
            }
        } else this.class = 'header-el-title-visible';
    }

    ngOnInit() {
        if (this.location.path() == '') {
            this.headerTransparent = false;
            this.class = 'header-el-title';
        } else {
            this.class = 'header-el-title-visible';
        }
    }

    getBackgroundColor() {
        if (this.openMenu) {
            this.icon = Icons.winWhite
            return ''
            // } return 'background: white'
        } else {
            if (this.headerTransparent) {
                this.icon = Icons.winWhite;
                this.background = 'red';
                return 'background: rgba(212, 66, 54, 1);'
            } else {
                this.icon = Icons.win;
                this.background = 'white';
                return 'background: white'
            }
        }

    }

    openHeaderMenu() {
        if (this.openMenu) {
            this.scroll.unlockScroll();
            if (this.location.path() == '') {
                if (!this.isTop) {
                    this.class = 'header-el-title';
                    this.headerTransparent = false;
                } else {
                    this.headerTransparent = (document.body.scrollHeight || document.documentElement.scrollHeight) -
                        this.heightService.getActiveHeight()  <
                        (window.scrollY || window.pageYOffset) + 75;
                    this.class = 'header-el-title-visible';
                    this.headerTransparent = false;
                }
            } else {
                this.headerTransparent = false;
            }
            // this.class = 'header-el-title-visible';
            this.openMenu = false;
        } else {
            this.scroll.lockScroll()
            this.openMenu = true;
            this.class = 'header-el-title-visible';
            this.headerTransparent = true;
        }
    }

    correctClick(title: string) {
        if (title == 'О проекте') {
            this.class = 'header-el-title';
        } else {
            this.class = 'header-el-title-visible';
        }
    }

    get image() {
        if (this.icon === Icons.winWhite) {
            return 'app/assets/new/remember-logo-white.png';
        }
        return 'app/assets/new/remember-logo-red.png';
    }

  protected readonly Icons = Icons;
}
